<div class="container">
  @if (this.isLoadingEditStakeholder()) {
    <app-loading-spinner-overlay
      [isLoading]="true"
      [screenReaderText]="'Loading subscription information...'"
    ></app-loading-spinner-overlay>
  }
  <h1>
    @if (projectInfo?.ProjectName) {
      <span> Subscribe to {{ projectInfo?.ProjectName }} </span>
    } @else {
      Update Subscription Information
    }
  </h1>
  <p class="description">
    @if (projectInfo?.ProjectDescription) {
      <span>
        {{ projectInfo?.ProjectDescription }}
      </span>
    }
  </p>

  <app-global-edit-stakeholder
    [projectInfo]="projectInfo"
    [stakeholderInfo]="stakeholderInfo"
    [isEdit]="isEdit"
    [goBackUrl]="'/subscription/search'"
    (formResult)="handleStakeholderEditCreateResult($event)"
  ></app-global-edit-stakeholder>
</div>
